<template>
  <section>
    <div class="strategy-card-contents">
      <h3>{{ formattedSectionHeading }}</h3>
      <SDIStrategyCard
        v-for="strategy in strategies"
        :key="`${guideline}-strategy-${htmlIDFromString(strategy.title)}`"
        :title="strategy.title"
        :description="strategy.description"
        :guideline="guideline"
        :trace-i-d="traceID"
      />
    </div>
  </section>
</template>

<script>
import { htmlIDFromString } from '@/util/html_utils'
import CopyButton from '@/components/CopyButton.vue'
import CopyTrackWrapper from '@/components/CopyTrackWrapper.vue'
import SDIStrategyCard from '@/components/sdistrategies/SDIStrategyCard.vue'

export default {
  name: 'SDIStrategiesResultsSection',
  components: { SDIStrategyCard, CopyTrackWrapper, CopyButton },
  methods: { htmlIDFromString },
  props: {
    guideline: {
      type: String,
      required: true
    },
    strategies: {
      type: Array,
      default() {
        return []
      }
    },
    traceID: {
      type: String,
      default: ''
    }
  },
  computed: {
    formattedSectionHeading() {
      return this.guideline + ' Strategies';
    },
  }
}
</script>

<style lang='less' scoped>
@import '~@/variables.less';

section {
  border-radius: 0.5rem;
  margin-bottom: 1.75rem;

  &:last-child {
    margin-bottom: 0;
  }

  .strategy-card-contents {
    background-color: white;
    border-radius: 0.4rem;
  }

  h3 {
    margin: 0 0 0.25rem 0;
    text-transform: uppercase;
    color: @gray-light;
    font-size: 0.875rem;
    font-weight: 500;
  }
}
</style>
